export default __webpack_public_path__ + "static/media/morjor_logo.5db6b74f.png";